export default "__VITE_ASSET__C_W4Qvod__"